import React from 'react';
import { SxProp, useSx } from 'dripsy';

import { Slider, ISliderProps } from '../../common/Slider';
import { useColors } from '@hooks';

const containerStyle: SxProp = {
  borderRadius: 2,
  width: 100,
};

export interface IVolumeSliderProps extends ISliderProps {}

export function VolumeSlider(props: IVolumeSliderProps) {
  const sx = useSx();
  const colors = useColors();

  return (
    <Slider
      {...props}
      containerStyle={sx(containerStyle)}
      sliderHeight={4}
      thumbWidth={12}
      renderBubble={() => null}
      theme={{
        minimumTrackTintColor: colors.$background0,
        maximumTrackTintColor: colors.$background50,
        bubbleBackgroundColor: colors.$background0,
      }}
    />
  );
}
